import { TraitLine } from '@discretize/gw2-ui-new';
import { List, ListItem, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import ConditionalWrapper from '../ConditionalWrapper';
import EmbossedCard from '../EmbossedCard';

const useStyles = makeStyles()((theme) => ({
  listItem: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > .gw2a--10x8O': {
      width: '100%',
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
      boxShadow: theme.shadows[2],
      overflow: 'hidden',
    },
  },
  title: {
    borderTop: `1px solid ${theme.palette.primary.dark}`,
    borderLeft: `1px solid ${theme.palette.divider}`,
    borderRight: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    padding: `${theme.spacing(0.5, 1)} !important`,
    borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
  },
}));

interface TraitsProps {
  unembossed?: boolean;
  title: string;
  traits1?: string[];
  traits2?: string[];
  traits3?: string[];
  traits1Id?: number;
  traits2Id?: number;
  traits3Id?: number;
  traits1SelectedIds?: number[];
  traits2SelectedIds?: number[];
  traits3SelectedIds?: number[];
}

function Traits({
  unembossed = false,
  title,
  traits1,
  traits1Id,
  traits1SelectedIds,
  traits2,
  traits2Id,
  traits2SelectedIds,
  traits3,
  traits3Id,
  traits3SelectedIds,
}: TraitsProps) {
  const { classes } = useStyles();

  return (
    <ConditionalWrapper
      condition={unembossed === undefined}
      wrapper={(children) => (
        <EmbossedCard title={title}> {children} </EmbossedCard>
      )}
    >
      <List dense>
        {traits1 && traits1Id && (
          <ListItem disableGutters className={classes.listItem}>
            <Typography variant="subtitle1" className={classes.title}>
              {traits1}
            </Typography>
            <TraitLine
              id={traits1Id}
              defaultSelected={traits1SelectedIds}
              selectable={false}
            />
          </ListItem>
        )}

        {traits2 && traits2Id && (
          <ListItem disableGutters className={classes.listItem}>
            <Typography variant="subtitle1" className={classes.title}>
              {traits2}
            </Typography>
            <TraitLine
              id={traits2Id}
              defaultSelected={traits2SelectedIds}
              selectable={false}
            />
          </ListItem>
        )}

        {traits3 && traits3Id && (
          <ListItem disableGutters className={classes.listItem}>
            <Typography variant="subtitle1" className={classes.title}>
              {traits3}
            </Typography>
            <TraitLine
              id={traits3Id}
              defaultSelected={traits3SelectedIds}
              selectable={false}
            />
          </ListItem>
        )}
      </List>
    </ConditionalWrapper>
  );
}

export default Traits;
